/* tslint:disable */
$.extend(NextMinutes.prototype,
{
    buildInnerView (event,__html, _br, __me,lls)
    {
        var i = 0;

        __html += `
            <div class="event_wrapper">
        `;

        while (i <= lls.length)
        {
            if (lls[i])
            {
                __html += `
                    <div class="betType betTypeRow oddsButtons">
                        <span class="wrap betTypeRowTitle">
                            ${lls[i].LineTypeName}
                        </span>
                `;
                //both exist and same line type ids - one could be missing when the line is not enabled
                if ((lls[i + 1]) && (lls[i].LineTypeID == lls[i + 1].LineTypeID))
                {
                    this.drawLine(lls[i], __html, _br, __me, event);
                    this.drawLine(lls[i + 1], __html, _br, __me, event);
                    i += 2;
                }
                else //different line
                {
                    if (this.isYesLine(lls[i])) //check to show first
                    {
                        this.drawLine(lls[i], __html, _br, __me, event);
                    }

                    this.drawLine({ Odds: 0, LineName: "<br/>" }, __html, _br, __me, event);

                    if (this.isYesLine(lls[i]) == false) //check to show second
                    {
                        this.drawLine(lls[i], __html, _br, __me, event);
                    }

                    i += 1;
                }
                __html += `
                    </div>
                `;
            }
            else
            {
                i += 2;
            }
        }

        __html += `
            </div>
        `;
    },

    drawLine (line, __html, _br, __me, event)
    {
        if (line.Odds != 0)
        {
            line.build(__html, _br, __me, event, true, 1);
        }
        else
        {
            __html += `
                <span class="wrap">
                    <span class="lnk_btn bet_btn betDisabled">
                        <span class="betDesc"><%=line.LineName%></span>
                    </span>
                </span>
            `;
        }
    }
});